import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';

export interface CostItem {
  id: string;
  name: string;
  amount: number;
  department: string;
  description?: string;
}

export interface Department {
  id: string;
  name: string;
  code: string;
}

@Component({
  selector: 'ops-move-cost-item-to-different-department',
  templateUrl: './ops-move-cost-item-to-different-department.component.html',
  styleUrl: './ops-move-cost-item-to-different-department.component.scss',
  standalone: false,
})
export class OpsMoveCostItemToDifferentDepartmentComponent implements OnInit, OnDestroy {
  @Input() costItem: CostItem | null = null;
  @Input() departments: Department[] = [];
  @Input() loading = false;
  @Input() disabled = false;

  @Output() moveItem = new EventEmitter<{ costItemId: string; newDepartmentId: string }>();
  @Output() cancel = new EventEmitter<void>();

  selectedDepartmentId: string = '';
  isVisible = false;
  subs: Array<Subscription> = [];

  constructor() {}

  ngOnInit(): void {
    if (this.costItem) {
      this.selectedDepartmentId = this.costItem.department;
    }
    // console.log('departments', this.departments);
    // console.log('selectedDepartmentId', this.selectedDepartmentId);
    // console.log('loading', this.loading);
    // console.log('disabled', this.disabled);
    // console.log('moveItem', this.moveItem);
    // console.log('cancel', this.cancel);
    // console.log('isVisible', this.isVisible);
    // console.log('subs', this.subs);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onMoveItem(): void {
    if (this.costItem && this.selectedDepartmentId && this.selectedDepartmentId !== this.costItem.department) {
      this.moveItem.emit({
        costItemId: this.costItem.id,
        newDepartmentId: this.selectedDepartmentId
      });
      return;
    }
    this.moveItem.emit({costItemId:"multiple", newDepartmentId:this.selectedDepartmentId});
  }

  onCancel(): void {
    this.cancel.emit();
  }

  getCurrentDepartmentName(): string {
    if (!this.costItem) return '';
    const currentDept = this.departments.find(dept => dept.id === this.costItem?.department);
    return currentDept?.name || this.costItem.department;
  }

  getSelectedDepartmentName(): string {
    if (!this.selectedDepartmentId) return '';
    const selectedDept = this.departments.find(dept => dept.id === this.selectedDepartmentId);
    return selectedDept?.name || this.selectedDepartmentId;
  }

  isMoveDisabled(): boolean {
    return this.loading || 
           this.disabled || 
          //  !this.costItem || 
           !this.selectedDepartmentId
  }
}
